<template lang="pug">
.article-wrap
  .left
    .crumbs
      a(:href="localePath('/')" v-t='"navigator.home"')
      span &nbsp;>&nbsp;
      a(:href="localePath('/articles')" v-t='"navigator.news"')
      span &nbsp;> {{article.title}}
    h1.article-title {{article.title}}
    time.time {{article.createTime | formatDate}}
    article.content(v-html="article.content")
  .right
    .article-list
      client-only
        a.item-wrap(v-for='(item, index) in list', :key='index', :href="localePath('/article/' + item.websiteParam)")
          img(v-lazy="item.coverImg || 'https://static.loklok.video/img/文章默认图.png'" alt="loklok news cover")
          .title {{item.title}}
    //- img(v-if="!list.length" src="https://img.rr.tv/0.7619296793792381%E5%BE%AE%E4%BF%A1.png" alt="recommend")
</template>
<script>
import config from '@/config'
import { formatDate } from '@/util'
import getStructuredJson from '@/util/structuredData'

export default {
  name: 'Article',
  components: {},
  async asyncData({ app, params, redirect, query, $ua }) {
    const id = params.id?.split('-')[0]
    try {
      const [res, res1] = await Promise.all([app.$api.getArticle(id), app.$api.getArticleRank()])
      const seoRes = await app.$api.queryKeyword()
      return {
        article: res,
        list: res1,
        seoKeyword: seoRes.keyword
      }
    } catch (e) {
      console.log('article error', e)
    }
  },
  data() {
    return {
      article: {},
      list: [],
      isInfiniteLoading: false,
      html: ''
    }
  },
  head() {
    return {
      title: this.article.title ? this.article.title + '- loklok news' : this.$t('seo.title') + '- loklok news',
      meta: [
        {
          name: 'keywords',
          content: `${this?.article?.keyword?.join(',')}${this.seoKeyword ? ',' + this.seoKeyword : ''}, Loklok, Loklok app, loklok download, loklok pc, loklok apk`
        },
        {
          hid: 'description',
          name: 'description',
          content: this.introduction || 'latest movie news' + '- Loklok, Loklok app, loklok download, loklok pc, loklok apk'
        },
        { rel: 'canonical', href: 'https://loklok.top' + this.localePath('/article/' + this.$route.params.id.split('-')[0]) }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: [
            getStructuredJson.bread([
              { name: this.$t('seo.index.title'), path: 'https://loklok.top' + this.localePath('/') },
              {
                name: this.article.title ? this.article.title + '- loklok news' : this.$t('seo.title') + '- loklok news',
                path: 'https://loklok.top' + this.localePath('/article/' + this.$route.params.id.split('-')[0])
              }
            ]),
            getStructuredJson.article(this.article)
          ]
        }
      ]
    }
  },
  filters: {
    formatDate(timestamp) {
      const date = new Date(timestamp)
      return formatDate(date, 'yyyy-MM-dd')
    }
  },
  computed: {},
  methods: {},
  watch: {},
  created() {}
}
</script>

<style lang="sass" scoped>
@import '~/styles'
.article-wrap
  width: 1240px
  margin: 0 auto
  padding-top: 20px
  @include flex-between
  align-items: flex-start
  .left
    width: 860px
    .crumbs
      font-weight: bold
      font-size: 14px
      line-height: 120%
      color: $mainDescTextColor
      margin-bottom: 20px
      a
        font-size: 14px
        color: $mainDescTextColor
    .article-title
      font-weight: bold
      font-size: 24px
      line-height: 150%
    .time
      margin-top: 20px
      margin-bottom: 20px
      font-weight: bold
      font-size: 14px
      line-height: 120%
      color: $mainDescTextColor
      display: block
  .right
    // padding-top: 130px
    width: 300px
    position: sticky
    top: 80px
    // top: 150px
    // bottom: 70px
    img
      width: 300px
      height: 168px
      border-radius: 4px
      display: block
      margin-left: auto
      margin-right: auto
    .article-list
      .item-wrap
        cursor: pointer
        display: block
        color: $mainTextColor
        margin-bottom: 40px
        width: 300px
        >img
          margin-bottom: 20px
          width: 100%
        .title
          font-weight: bold
          font-size: 14px
          line-height: 150%
          @include ellipsis-multi(2)
        &:hover
          color: $mainColor
.content
  font-size: 16px
  font-weight: bold
  line-height: 200%
  text-align: justify
  color: $mainDescTextColor
  :deep h1
    margin-top: 20px
    margin-bottom: 20px
  :deep h2
    margin-top: 20px
    margin-bottom: 20px
  :deep h3
    margin-top: 20px
    margin-bottom: 20px
  :deep h4
    margin-top: 20px
    margin-bottom: 20px
  :deep h5
    margin-top: 20px
    margin-bottom: 20px
  :deep p
    margin-top: 20px
    margin-bottom: 20px
  :deep img
    max-width: 100%
    margin-top: 12px
    display: block
    margin-left: auto
    margin-right: auto
  :deep a
    color: $mainColor
@media screen and (max-width: 1240px)
  .article-wrap
    width: 100%
    padding: 20px 30px
    .left
      width: calc( 100% - 300px - 40px )
      margin-bottom: 20px
@media screen and (max-width: 750px)
  .article-wrap
    flex-direction: column
    align-items: center
    width: 100%
    padding: 20px 16px
    .left
      width: 100%
      margin-bottom: 20px
      padding: 0
    .right
      width: 100%
      display: flex
      flex-wrap: wrap
      justify-content: space-around
      .article-list
        &::after
          content: ' '
          display: block
          width: 300px
</style>
